export default {
  width: 12,
  height: 12,
  svg: `
<path fill-rule="nonzero" d="M1 12h3c.3 0 .5-.1.7-.3l7-7c.4-.4.4-1 0-1.4l-3-3c-.4-.4-1-.4-1.4 0l-7 7c-.2.2-.3.4-.3.7v3c0 .6.4 1 1 1zm1-3.6l6-6L9.6 4l-6 6H2V8.4z"/>  
  `
}
